import { instantBaseApi } from "../instantApi";
import { submitSurvey } from "./gpl";

export const surveyApi = {

  submitSurveyApi : async ({ surveyHandle, surveyData }) => {
    return await instantBaseApi(
      JSON.stringify({
        query: submitSurvey,
        variables: {
          handle: surveyHandle,
          input: {
            data: JSON.stringify(surveyData),
          },
        }
      })
    );
  }
};
